import React from 'react';
export function Footer() {
  return <footer className="bg-navy-900 px-5 pb-28 pt-14 sm:pb-14" data-id="element-95" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl text-center" data-id="element-96" data-mp="3gfitoga0y7d2">
        <p className="font-display text-xl font-black text-gold" data-id="element-97" data-mp="3gh3q6bfwg0dk">
          🏏 CRICKET READY™
        </p>
        <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-white/55" data-id="element-98" data-mp="32m1c310wf4po">
          The #1 planning system for cricket coaches worldwide. Because coaching
          shouldn't cost you every evening of the week.
        </p>

        <div className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/70" data-id="element-99" data-mp="38z8yrj06z2w">
          <a href="mailto:support@cricketready.com" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-100" data-mp="3ldaobi2207ky">
            📧 support@cricketready.com
          </a>
          <span data-id="element-101" data-mp="29ydxc2mb78ay">📲 @cricketready</span>
          <span data-id="element-102" data-mp="2a1jk3b7gty3i">🌐 www.cricketready.com</span>
        </div>

        <p className="mt-10 border-t border-white/10 pt-6 text-[11px] uppercase tracking-[0.16em] text-white/35" data-id="element-103" data-mp="2ez1nkm2prl44">
          © Cricket Ready™ 2026 — All Rights Reserved.
        </p>
      </div>
    </footer>;
}